// Send CSP nonce on Turbo requests for nonce reuse
// This ensures inline scripts in Turbo responses use the same nonce as the original page
// https://github.com/hotwired/turbo/issues/294
document.addEventListener('turbo:before-fetch-request', (event) => {
  const cspMeta = document.querySelector('meta[name="csp-nonce"]')
  if (cspMeta) {
    const { fetchOptions } = (event as CustomEvent).detail
    fetchOptions.headers['X-Turbo-Nonce'] = cspMeta.getAttribute('content') || ''
  }
})
